import {shallowRef} from 'vue';

export function useFilesPath(host = '') {
    const baseHost = shallowRef(host);

    function filePath(path, baseUrl = baseHost.value) {
        if (!path) {
            return;
        }

        try {
            const resultPath = path.charAt(0) === '/' ? path.slice(1) : path;

            return new URL(resultPath, baseUrl).href;
        } catch (error) {
            console.error(error);
        }
    }

    function officeImagePath(imageName, baseUrl = baseHost.value) {
        return `${baseUrl}images/office-photo/${imageName}`;
    }

    return {
        filePath,
        officeImagePath,
    };
};
